import React, { Component } from 'react'

import ElementContainer from '../common/ElementContainer'
import { faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import EditableLabel from '../common/EditableLabel'

export default class URLParam extends Component {
  static weight = 1

  static defaultConfig = {
    id: 0,
    type: 'URLParam',
    label: 'URL Parameter'
  }

  static metaData = {
    icon: faWindowMaximize,
    displayText: 'URL Parameter',
    group: 'inputElement'
  }

  static configurableSettings = {
    searchUrlParam: {
      default: '',
      formProps: {
        type: 'TextBox',
        label: 'Url Parameter',
        placeholder: ''
      }
    },
    hidden: {
      default: '',
      formProps: {
        type: 'Checkbox',
        options: ['Hide the input on the form']
      }
    }
  }

  static submissionHandler = {
    findQuestionValue: (inputs, qid) => {
      let value = ''
      for (const elem of inputs) {
        if (elem.q_id === qid && elem.value) {
          value = elem.value
        }
      }
      return value
    }
  }

  static getPlainStringValue(entry) {
    let plainString

    if (entry.value !== '') {
      plainString = entry.value
    } else {
      plainString = '-'
    }

    return plainString
  }

  static renderDataValue(entry) {
    return entry.value ? entry.value : '-'
  }

  static helpers = {
    getElementValue: 'defaultInputHelpers',
    isFilled: 'defaultInputHelpers'
  }
  render() {
    const { config, mode } = this.props
    const inputProps = {}

    if (typeof config.value !== 'undefined') {
      inputProps.value = config.value
    }

    if (typeof config.defaultValue !== 'undefined') {
      inputProps.defaultValue = config.defaultValue
    }

    if (typeof this.props.onChange !== 'undefined') {
      inputProps.onChange = this.props.onChange
    }

    if (typeof config.placeholder !== 'undefined') {
      inputProps.placeholder = config.placeholder
    }

    if (typeof config.maxLength !== 'undefined') {
      inputProps.maxLength = config.maxLength
    }

    const searchUrlParam = config.searchUrlParam

    let scriptInnerHtml = `
      (() => {
      const input = document.getElementById('q_${config.id}')
      const urlParams = new URLSearchParams(window.location.search)
        const searchParam = urlParams.get('${searchUrlParam}')
        console.log('searchParam', searchParam)
        if (searchParam) {
            input.value = searchParam
         }
      
      
      })()
    `
    const script = (
      <script key={5} dangerouslySetInnerHTML={{ __html: scriptInnerHtml }} />
    )
    return (
      <ElementContainer type={config.type} {...this.props}>
        {mode === 'renderer' && config.hidden ? (
          <input
            id={`q_${config.id}`}
            name={`q_${config.id}`}
            {...inputProps}
            hidden
          />
        ) : (
          <>
            <div className="elemLabelTitle">
              <EditableLabel
                className="fl label"
                dataPlaceholder="Type a question"
                mode={mode}
                labelKey={config.id}
                handleLabelChange={this.props.handleLabelChange}
                value={config.label}
                required={config.required}
              />
            </div>
            <div className="fl input">
              <input
                id={`q_${config.id}`}
                name={`q_${config.id}`}
                {...inputProps}
              />
            </div>
            {mode === 'viewer' ? (
              ''
            ) : (
              <div className="clearfix">
                <EditableLabel
                  className="sublabel"
                  dataPlaceholder="Click to edit sublabel"
                  mode={mode}
                  labelKey={`sub_${config.id}`}
                  handleLabelChange={this.props.handleLabelChange}
                  value={
                    typeof config.sublabelText !== 'undefined' &&
                    config.sublabelText !== ''
                      ? config.sublabelText
                      : ''
                  }
                />
              </div>
            )}
            <div className="fl metadata">
              <div className="requiredErrorText">{config.requiredText}</div>
            </div>
          </>
        )}

        {script && script}
      </ElementContainer>
    )
  }
}
